export const MEDIA_QUERY_MOBILE = 768;
